var QawafilStoreFrontCart = (function() {
    'use strict';

    var isMiniCartLoading = false;

    function registerCartEvents(){
        var cart_count_session =  0;

            cart_count_session = parseInt($('#cart_count').text());
            if(cart_count_session === 0) $('.cart_summary_toggle').hide();
            else $('.cart_summary_toggle').show();

            $(document).on('click',  '.remove_cart_item_btn',function(){
                let id = $(this).attr('data-id');
                consoleLog('remove item ', id);
                QawafilStoreFrontCart.removeCartItem(id);
            });

            $(document).on('click', '.clear_cart_btn',function(){
                QawafilStoreFrontCart.clearCart();
            });

            $(document).on('click',  '.increase_cart_item_btn',function(){
                let id = $(this).attr('data-id');
                consoleLog('increase item qty ', id);
                QawafilStoreFrontCart.updateItemQuantity(id, 'plus');
            });

            $(document).on('click',  '.decrease_cart_item_btn',function(){
                let id = $(this).attr('data-id');
                consoleLog('decrease item qty ', id);
                QawafilStoreFrontCart.updateItemQuantity(id, 'minus');
            });

            $(document).on('keypress','.cart_item_qty_input',  function(e){
                if(e.which == 13) {
                    let id = $(this).attr('data-id');
                    QawafilStoreFrontCart.updateItemQuantity(id, $(this).val());
                }
            });

            $('#mini_cart_btn').on('click', function () {
                // let IsDropdownOpened = $(this).parent().find('.minicart-drop').hasClass('opened') || $(this).closest('.minicart-js').hasClass('active');
                if( !isMiniCartLoading){
                    isMiniCartLoading = true;
                    QawafilStoreFrontCart.loadMiniCartItems();
                }
            });

    }


    var updateCartInHeader  = function (cartObj){
        if(cartObj){
            $('#cart_count').text(cartObj.items.length);
            $('.cart_subtotal').html(`${cartObj.subtotal} ${QawafilStoreFront.helpers.getCurrencyIconHtml()}`);

            if(cartObj.items.length > 0 ){
                $('.cart_summary_toggle').show();
                $('.cart_empty_content').hide();
            }else{
                // consoleLog('cart is empty');
                $('.cart_empty_content').show();
                $('.cart_summary_toggle').hide();
                $('.errors-heading').hide();
            }
        }
    }

    var resetCartData = function (){

        $('#cart_count').text(0);
        $('.cart_subtotal').html(`0${QawafilStoreFront.helpers.getCurrencyIconHtml()}`);
        $('.cart_empty_content').show();
        $('.cart_summary_toggle').hide();
        $('.errors-heading').hide();

    }

    var removeItemHtml = function(id){
        $('.cart_item_' + id).slideUp("slow", function() {
            $(this).remove();
        });
    }


    var addCartItem = function (productId, qty,variationId, customFields = null) {
        console.log('add to cart');
        if (qty == null || qty === '')  qty = 1;
        var formData = new FormData();
        formData.append('product_id', productId);
        formData.append('quantity', qty);
        formData.append('variation_id', variationId);
        if(customFields){
            for(var key in customFields){
                formData.append(key, customFields[key]);
            }
        }
        Qawafil.cart.addToCart(formData, function (response){
            if(response){
                if(response.status){
                    if(response.message) toastSuccess(response.message)
                    updateCartInHeader(response.data ? response.data.cart : null)
                }
                else{
                    if(response.message && response.code !== 401 && response.code !== 403) toastError(response.message)
                }
            }
            else{
                toastError();
            }

        });
    };

    var removeCartItem = function(id){
        // $('#btn-remove-' + id).attr('disabled', true);

        Qawafil.cart.deleteItem(id, function (response){
            if(response){
                if(response.status){
                    if(response.message) toastSuccess(response.message)
                    console.log('handle removeCartItem response')
                    removeItemHtml(id);
                    updateCartInHeader(response.data? response.data.cart : null)
                }
                else{
                    if(response.message && response.code !== 403) toastError(response.message)
                }
            }
            else{
                toastError();
            }
        });

    }

    var clearCart = function(){

        Qawafil.cart.clearCart(function(response){
            if(response){
                if(response.status){
                    if(response.message) toastSuccess(response.message)
                    $('[class*=cart_item_]').slideUp("slow", function() {
                        $(this).remove();
                    });
                    resetCartData();
                }
                else{
                    if(response.message && response.code !== 403) toastError(response.message)
                }
            }
            else{
                toastError();
            }

        })
    }

    var updateItemQuantity = function(cart_item_id, update){
        consoleLog('update',update);
        let old_quantity = $('#quantity-' + cart_item_id).data('quantity');
        let new_quantity = 0;

        if(update == 'plus'){
            new_quantity = old_quantity + 1 ;
        }
        else if(update == 'minus'){
            new_quantity = old_quantity - 1 ;
        }
        else if(!isNaN(update)){
            new_quantity = update;
        }
        else{
            return;
        }
        consoleLog('old_quantity',old_quantity);
        consoleLog('new_quantity',new_quantity);

        if(new_quantity <= 0){
            toastError('الكمية يجب أن تكون أكبر من صفر');
            return;
        }

        Qawafil.cart.updateItemQuantity(cart_item_id, new_quantity, function (response){
            if(response){
                if(response.status){
                    if(response.message) toastSuccess(response.message)
                    // $(`.cart_item_${cart_item_id}`).replaceWith(response.data.item_component);
                    updateCartInHeader(response.data ? response.data.cart : null);
                    $('#quantity-' + cart_item_id).data('quantity', new_quantity);
                }
                else{
                    if(response.message && response.code !== 403) toastError(response.message);
                    $(`#quantity-${cart_item_id}`).val(old_quantity);
                }
            }
            else{
                toastError();
            }

        })

    }

    var loadMiniCartItems = function (){
        QawafilStoreFront.helpers.blockPage();
        $.ajax({
            url: '/shopping-cart',
            method: 'GET',
            success: function (response) {
                // Assuming the response is the full HTML page
                const $response = $(response); // Wrap the response in a jQuery obj

                // Find the cart_items_container in the response
                const cartItemsHTML = $response.find('#cart_items_container').html();
                const cartSubtotal = $response.find('.cart_subtotal').html();

                // Check if the cart_items_container has items
                if (cartItemsHTML.trim() === '') {
                    $('.cart_empty_content').show();
                    $('#mini_cart_checkout_link').addClass('disabled');
                } else {
                    $('.cart_empty_content').hide();
                    $('#mini_cart_checkout_link').removeClass('disabled');
                    $('#mini_cart_checkout_link').attr('href', $response.find('#cart_checkout_link').attr('href'));
                }
                // Append the extracted HTML to mini_cart_container
                $('#mini_cart_container').html(cartItemsHTML);
                $('.minicart-drop .cart_subtotal').html(cartSubtotal);
            },
            error: function (error) {
                console.log('Error:', error);
            },
            complete: function (){
                isMiniCartLoading = false;
                QawafilStoreFront.helpers.unBlockPage();
            }
        });
    }

    function init(){
        registerCartEvents();
    }

    return {
        init: init,
        addCartItem: addCartItem,
        removeCartItem: removeCartItem,
        clearCart: clearCart,
        updateItemQuantity: updateItemQuantity,
        loadMiniCartItems: loadMiniCartItems
    };

})();
